import PropTypes from 'prop-types';
import React from 'react';

import './DropdownBox.scss';

class DropdownBox extends React.Component {
  static propTypes = {
    dropdownType: PropTypes.any,
    children: PropTypes.node.isRequired,
  };

  render() {
    return <ul className='DropdownBox'>{this.props.children}</ul>;
  }
}

export default DropdownBox;
